import {
  listUnreadReleaseNotes,
  markReleaseNotesAsRead,
} from '@/services/system-settings/feedback-management';
import type { ReleaseNoteItem } from '@/services/system-settings/feedback-management';
import { history } from '@umijs/max';
import { Modal, Space, Tag, Typography } from 'antd';
import React, { useEffect, useState } from 'react';

interface ReleaseNoticeModalProps {
  enabled?: boolean;
}

const loginPath = '/user/login';
const profilePath = '/profile';

const ReleaseNoticeModal: React.FC<ReleaseNoticeModalProps> = ({ enabled }) => {
  const [checked, setChecked] = useState(false);
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState<ReleaseNoteItem[]>([]);

  useEffect(() => {
    const loadUnreadReleaseNotes = async () => {
      if (!enabled || checked) return;
      const pathname = history.location.pathname;
      if (pathname === loginPath || pathname === profilePath) return;
      setChecked(true);
      try {
        const result = await listUnreadReleaseNotes({ skipErrorHandler: true });
        const unread = result.data || [];
        if (unread.length > 0) {
          setItems(unread);
          setOpen(true);
        }
      } catch {
        // 更新通知の取得失敗はログイン後の通常利用を妨げない。
      }
    };

    loadUnreadReleaseNotes();
  }, [checked, enabled]);

  const handleConfirm = async () => {
    const releaseIds = items
      .map((item) => item.releaseId)
      .filter((id): id is number => typeof id === 'number');
    if (releaseIds.length > 0) {
      await markReleaseNotesAsRead(releaseIds);
    }
    setOpen(false);
  };

  return (
    <Modal
      title="更新情報のお知らせ"
      open={open}
      width={680}
      okText="確認しました"
      cancelButtonProps={{ style: { display: 'none' } }}
      onOk={handleConfirm}
      onCancel={handleConfirm}
      destroyOnClose
    >
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        {items.map((item) => (
          <div
            key={item.releaseId}
            style={{
              border: '1px solid #f0f0f0',
              borderRadius: 8,
              padding: 14,
              background: '#fff',
            }}
          >
            <Space style={{ marginBottom: 8 }} wrap>
              <Typography.Text strong>{item.title}</Typography.Text>
              <Tag color="blue">{item.versionNo}</Tag>
              {item.importantFlag === 1 && <Tag color="red">重要</Tag>}
              <Typography.Text type="secondary">{item.releaseDate}</Typography.Text>
            </Space>
            <Typography.Paragraph style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
              {item.content}
            </Typography.Paragraph>
          </div>
        ))}
      </Space>
    </Modal>
  );
};

export default ReleaseNoticeModal;
